<mat-expansion-panel
  class="mat-expansion-panel"
  data-testid="av-check-audio-select"
  [expanded]="true"
>
  <mat-expansion-panel-header>
    <mat-panel-title data-testid="av-check-audio-title"
      ><mat-icon svgIcon="microphone"></mat-icon>Audio</mat-panel-title
    >
  </mat-expansion-panel-header>

  <div class="mat-expansion-panel__body">
    <div class="custom-select">
      <app-select-input
        [dataTestId]="'av-check-microphone'"
        [isDisabled]="!micCheckService.selectAudioInputDevices().length"
        [isFullWidth]="true"
        [label]="'Select Microphone'"
        [options]="micOptions()"
        [placeholder]="'No Microphone Selected'"
        [value]="micCheckService.currentMicDevice()?.label || ''"
        (selectionChange)="handleMicrophoneSelectionChange($event)"
      ></app-select-input>
      <mat-progress-bar
        [ngClass]="micCheckService.micBarProgressClass()"
        [value]="micCheckService.micBarProgress()"
        class="rkt-ProgressBar disable-animations"
        mode="determinate"
      />
    </div>
    <ng-container *ngTemplateOutlet="micIconContainer" />
  </div>

  <span class="hint"
    >Hint: Speak into your microphone and make sure the bar above turns green.</span
  >
  @if (micFailure()) {
  <app-av-check-guide
    [showButton]="audioVideoCheckService.isBrowserDetected"
    [(showDetails)]="showMicrophoneGuideDetails"
  >
    <p>
      Hi there! It looks like your microphone might be blocked by your browser. Let's get this
      sorted out.
    </p>

    @if (showMicrophoneGuideDetails) { @if (hasGadgetGuideForMicrophoneLoadingFailure()) {
    <p>
      We're having trouble accessing your microphone. Please make sure your microphone is connected
      and try again.
    </p>
    } @else { @if (isGadgetGuideForMicrophoneLoading()) {
    <app-skeleton-text [width]="'med'"/>
    } @else {
    <app-gadget-guide-response [gadgetGuide]="gadgetGuideServiceMicrophoneResponse()" />
    } } }
  </app-av-check-guide>
  } @if (speakerCheckService.hasSpeakerFeature()) {
  <div class="mat-expansion-panel__body">
    <div class="custom-select">
      <app-select-input
        [dataTestId]="'av-check-speaker'"
        [isDisabled]="!speakerCheckService.selectAudioOutputDevices().length"
        [isFullWidth]="true"
        [label]="'Select Speaker'"
        [options]="speakerOptions()"
        [placeholder]="'No Speaker Selected'"
        [value]="speakerCheckService.selectAudioOutputDevice()?.label || ''"
        (selectionChange)="handleSpeakerSelectionChange($event)"
      ></app-select-input>
      <mat-progress-bar
        [ngClass]="speakerCheckService.matProgressBarClass"
        [value]="speakerCheckService.audioLevel"
        class="rkt-ProgressBar disable-animations"
        mode="determinate"
      />
    </div>
    <ng-container *ngTemplateOutlet="speakerIconContainer" />
  </div>
  @if (speakerFailure()) {
  <app-av-check-guide
    [showButton]="audioVideoCheckService.isBrowserDetected"
    [(showDetails)]="showSpeakerGuideDetails"
  >
    <p>
      Hi there! It looks like your speaker might be blocked by your browser. Let's get this sorted
      out.
    </p>

    @if (showSpeakerGuideDetails) { @if (hasGadgetGuideForSpeakerLoadingFailure()) {
    <p>
      We're having trouble accessing your speaker. Please make sure your speaker is connected and
      try again.
    </p>
    } @else { @if (isGadgetGuideForSpeakerLoading()) {
    <app-skeleton-text [width]="'med'"/>
    } @else {
    <app-gadget-guide-response
      [gadgetGuide]="gadgetGuideServiceSpeakerResponse()"
    ></app-gadget-guide-response>
    } } }
  </app-av-check-guide>
  }

  <ng-container mat-action-row>
    <app-button
      (buttonClick)="!shouldDisableSpeakerTestButton() && speakerCheckService.testSpeaker()"
      [isDisabled]="shouldDisableSpeakerTestButton()"
      class="speaker-test"
      size="small"
      type="secondary"
      [dataTestId]="'test-speaker-button-avcheck'"
    > <mat-icon svgIcon="play_music"></mat-icon>
      Test Speaker
    </app-button>
  </ng-container>
  }
</mat-expansion-panel>

<ng-template #micIconContainer>
  <div class="mat-expansion-panel__info-icon-container">
    @if (micFailure()) {
    <mat-icon svgIcon="error" title="Microphone Selection Error"></mat-icon>
    } @else {
    <mat-icon svgIcon="success" title="Microphone Selection Success"></mat-icon>
    }
  </div>
</ng-template>

<ng-template #speakerIconContainer>
  <div class="mat-expansion-panel__info-icon-container">
    @if (speakerFailure()) {
      <mat-icon svgIcon="error" title="Speaker Selection Error"></mat-icon>
    } @else {
      <mat-icon svgIcon="success" title="Speaker Selection Success"></mat-icon>
    }
  </div>
</ng-template>
